/* "What's in the Shop" inventory wall — renders window.GG_INVENTORY (js/inventory-data.js,
   generated from the POS by build-inventory-data.cjs). Search + category chips + show-more.
   Images resolve via window.GG_DROPS_BASE so the same code works on the static preview and
   on Shopify's flattened assets. */
(function () {
  "use strict";
  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }
  var data = window.GG_INVENTORY || [];
  var grid = document.getElementById("invGrid");
  if (!grid || !data.length) return;
  var base = window.GG_DROPS_BASE || "assets/new/pos/";
  var PAGE = 24;
  var query = "", cat = "All", shown = PAGE;

  var counts = {};
  data.forEach(function (d) { counts[d.t] = (counts[d.t] || 0) + 1; });
  var cats = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).slice(0, 12);

  var chips = document.getElementById("invChips");
  var searchEl = document.getElementById("invSearch");
  var moreBtn = document.getElementById("invMore");
  var countEl = document.getElementById("invCount");

  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  function filtered() {
    var q = query.toLowerCase();
    return data.filter(function (d) {
      if (cat !== "All" && d.t !== cat) return false;
      if (q && d.n.toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
  }
  function render() {
    var list = filtered();
    grid.innerHTML = list.slice(0, shown).map(function (d) {
      return '<figure class="inv-card"><span class="inv-card__media"><img src="' + base + d.img +
        '" alt="' + esc(d.n) + '" loading="lazy" decoding="async" onerror="this.closest(&quot;figure&quot;).remove()"></span>' +
        "<figcaption><b>" + esc(d.n) + "</b><i>" + esc(d.t) + "</i></figcaption></figure>";
    }).join("");
    if (countEl) countEl.textContent = tr("{n} items in stock").replace("{n}", list.length);
    if (moreBtn) moreBtn.hidden = shown >= list.length;
  }
  if (chips) {
    chips.innerHTML = ["All"].concat(cats).map(function (c) {
      return '<button type="button" class="inv-chip' + (c === "All" ? " is-on" : "") + '" data-cat="' + esc(c) + '">' +
        esc(c === "All" ? tr("All") : c) + (c === "All" ? "" : " · " + counts[c]) + "</button>";
    }).join("");
    chips.addEventListener("click", function (e) {
      var b = e.target.closest(".inv-chip");
      if (!b) return;
      cat = b.getAttribute("data-cat");
      shown = PAGE;
      Array.prototype.forEach.call(chips.querySelectorAll(".inv-chip"), function (x) { x.classList.toggle("is-on", x === b); });
      render();
    });
  }
  if (searchEl) {
    searchEl.addEventListener("input", function () { query = searchEl.value.trim(); shown = PAGE; render(); });
  }
  if (moreBtn) moreBtn.addEventListener("click", function () { shown += PAGE * 2; render(); });
  render();
})();
